/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useIonViewWillEnter } from "@ionic/react";
import PageWrapper from "../layouts/PageWrapper";
import { useStatements } from "../../hooks/useStatements";
import { StatementModel } from "../../models/GlobalModels";
import StatementItem from "../../components/StatementItem";
import { useAppSelector } from "../../store/hooks";

import "./DatamodPage.scss";

const StatementsPage: React.FC = () => {
    const {
        // statements,
        fetchStatements,
        acceptStatement,
        acceptStatementLoading,
    } = useStatements();
    const [filteredStatements, setFilteredStatements] = useState<
        StatementModel[]
    >([]);
    const statements = useAppSelector((state) => state.statement.statements);

    useIonViewWillEnter(() => {
        fetchStatements();
    });

    useEffect(() => {
        if ((statements ?? []).length > 0) {
            const latestMap = new Map<number, StatementModel>();
            statements.forEach((item) => {
                const prev = latestMap.get(item.type);
                if (
                    !prev ||
                    new Date(item.valid_from) > new Date(prev.valid_from)
                ) {
                    latestMap.set(item.type, item);
                }
            });

            setFilteredStatements(Array.from(latestMap.values()));
        }
    }, [statements]);

    return (
        <PageWrapper>
            <div className="hasButton">
                <h1 className="pageTitle">Hozzájáruló nyilatkozatok</h1>
            </div>

            {filteredStatements.map((statement) => (
                <div key={statement.id} style={{ marginBottom: "10px" }}>
                    <StatementItem
                        key={statement.id}
                        statement={statement}
                        onAcceptStatement={acceptStatement}
                        acceptStatementLoading={acceptStatementLoading}
                    />
                </div>
            ))}
        </PageWrapper>
    );
};

export default StatementsPage;
